import { useRef, useCallback } from 'react';

function useGetAndSet(initialValue) {
  const ref = useRef();
  const initialized = useRef(false);
  if (!initialized.current) {
    ref.current = typeof initialValue === "function" ? initialValue() : initialValue;
    initialized.current = true;
  }
  const get = useCallback(() => ref.current, []);
  const set = useCallback((value) => {
    ref.current = typeof value === "function" ? value(ref.current) : value;
  }, []);
  return [get, set];
}

export { useGetAndSet };
//# sourceMappingURL=useGetAndSet.js.map
